import React, { useContext, useEffect, useState } from 'react'
import { AmountInWords } from '../../../../Utility/function';
import { WarehouseContext } from '../../../../Utility/UserContext';

const SalesPrintModal = ({ showModal, setShowModal, ref, InvoiceDetail, Products, ReturnItem, Payment, paidAmount }) => {
    const { shopItem } = useContext(WarehouseContext);
    const [data, setdata] = useState(shopItem);
    const [selectedLanguage, setSelectedLanguage] = useState("english");
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "",
                address: shopItem?.Address || "123 Business Street, City, State 12345",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            })
        }
    }, [shopItem])

    const toggleExpand = (index) => {
        setExpandedIndex(prev => (prev === index ? null : index));
    };

    return (
        <div
            className={`modal fade bg-light-transparent ${showModal ? "show" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showModal ? "block" : "none" }}
            aria-hidden={!showModal}
        >
            <div
                className={`modal-dialog modal-lg`}
                role="document"
            >
                <div className="modal-content" ref={ref}>
                    <div className="modal-header border-0 pb-0 mb-1">
                        <button
                            type="button"
                            className="btn-close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setShowModal(false)}
                        ></button>
                    </div>

                    <>
                        <div className="d-flex justify-content-end mt-2 mx-4">
                            <div className="form-check form-check-inline mx-1">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="language"
                                    id="english"
                                    value="english"
                                    checked={selectedLanguage === "english"}
                                    onChange={() => setSelectedLanguage("english")}
                                />
                                <label className="form-check-label" htmlFor="english">
                                    English
                                </label>
                            </div>
                            <div className="form-check form-check-inline ">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="language"
                                    id="arabic"
                                    value="arabic"
                                    checked={selectedLanguage === "arabic"}
                                    onChange={() => setSelectedLanguage("arabic")}
                                />
                                <label className="form-check-label" htmlFor="arabic">
                                    العربية
                                </label>
                            </div>
                        </div>

                        <div className="row mx-3 mt-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="col-md-1">
                                    <img
                                        src="assets/images/tech_logo.webp"
                                        alt="Left Logo"
                                        style={{ maxHeight: "38px" }}
                                    />
                                </div>
                                <div>
                                    <img
                                        src="assets/images/arabic.jpg"
                                        alt="Left Logo"
                                        style={{ maxHeight: "38px" }}
                                    />
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <p className="fw-bold font-14 mb-0">
                                    {companyInfo?.address}
                                </p>
                                <p className="fw-medium font-13 mb-0">
                                    Mobile: {companyInfo?.phone} |
                                    Email: {companyInfo?.email}
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col text-center">
                                <h3
                                    className="fw-bold mt-2"
                                    style={{ textDecoration: "underline" }}
                                ></h3>
                                <h3 className="fw-bold">
                                    {" "}
                                    {selectedLanguage === "arabic" ? "فاتورة" : "Invoice"}
                                </h3>
                            </div>
                        </div>

                        <div className="row border-top border-bottom pt-3 mx-3 pb-2">
                            <div className="col-6">
                                <div
                                    className="p-2"
                                    style={{
                                        border: ".8px solid #dee2e6",
                                        minHeight: 150,
                                    }}
                                >
                                    <h6 className="fw-bold">
                                        {selectedLanguage === "arabic"
                                            ? "تفاصيل العميل:"
                                            : "Customer Details:"}
                                    </h6>
                                    <div className="d-flex justify-content-between">
                                        <p className="fw-medium font-13 mb-1">
                                            {selectedLanguage === "arabic" ? "الاسم:" : "Name:"}
                                        </p>
                                        <p
                                            className="fw-bold font-13 mb-1"
                                            style={{ textDecoration: "underline" }}
                                        >
                                            {InvoiceDetail.customer_name}
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="fw-medium font-13 mb-1">
                                            {selectedLanguage === "arabic"
                                                ? "البريد الإلكتروني:"
                                                : "Email:"}
                                        </p>
                                        <p
                                            className="fw-bold font-13 mb-1"
                                            style={{ textDecoration: "underline" }}
                                        >
                                            {InvoiceDetail.customer_email}
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="fw-medium font-13 mb-1">
                                            {selectedLanguage === "arabic"
                                                ? "العنوان:"
                                                : "Address:"}
                                        </p>
                                        <p
                                            className="fw-bold font-13 mb-1"
                                            style={{ textDecoration: "underline" }}
                                        >
                                            {InvoiceDetail.additional_details}
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <p className="fw-medium font-13 mb-1">
                                            {selectedLanguage === "arabic"
                                                ? "الهاتف:"
                                                : "Phone:"}
                                        </p>
                                        <p
                                            className="fw-bold font-13 mb-1"
                                            style={{ textDecoration: "underline" }}
                                        >
                                            {InvoiceDetail.customer_phone}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <table className="table table-bordered text-center align-middle m-0">
                                    <tbody>
                                        <tr>
                                            <td className="text-start fw-bold">
                                                {selectedLanguage === "arabic"
                                                    ? "رقم الفاتورة:"
                                                    : "Invoice No:"}
                                                {InvoiceDetail?.unique_id}
                                            </td>
                                            <td className="text-start fw-bold">
                                                {selectedLanguage === "arabic"
                                                    ? "التاريخ:"
                                                    : "Date:"}{" "}
                                                {InvoiceDetail?.date}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="table table-bordered text-center align-middle">
                                    <tbody>
                                        <tr>
                                            <td className="text-start d-flex flex-row">
                                                <p
                                                    className="fw-bold text-start mb-0"
                                                    style={{ width: "40%" }}
                                                >
                                                    {selectedLanguage === "arabic"
                                                        ? "رقم الطلب:"
                                                        : "L.P.O No:"}
                                                </p>
                                                <p
                                                    className="text-start mb-0"
                                                    style={{ width: "60%" }}
                                                >
                                                    {InvoiceDetail.lpo_no}{" "}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-start d-flex flex-row">
                                                <p
                                                    className="fw-bold text-start mb-0"
                                                    style={{ width: "40%" }}
                                                >
                                                    {selectedLanguage === "arabic"
                                                        ? "البائع:"
                                                        : "Sales Person:"}
                                                </p>
                                                <p
                                                    className="text-start mb-0"
                                                    style={{ width: "60%" }}
                                                >
                                                    {InvoiceDetail.user_name}{" "}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-start d-flex flex-row">
                                                <p
                                                    className="fw-bold text-start mb-0"
                                                    style={{ width: "40%" }}
                                                >
                                                    {selectedLanguage === "arabic"
                                                        ? "شروط الدفع:"
                                                        : "Payment Terms:"}
                                                </p>
                                                <p
                                                    className="text-start mb-0"
                                                    style={{ width: "60%" }}
                                                >
                                                    {InvoiceDetail?.purchase_unit == 1 ? "Cash" : "Credit"}
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row mt-4 mx-4">
                            <div
                                className="col-md-12"
                                style={{
                                    position: "relative",
                                    overflow: "hidden",
                                    background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
                                    backgroundSize: "60%",
                                    backgroundPosition: "center",
                                }}
                            >
                                <div className="table-responsive">
                                    <table className=" border table-sm table-bordered w-100">
                                        <thead className="table-light">
                                            <tr className="bg-transparent">
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "الرقم"
                                                            : "SL No."}
                                                    </span>
                                                </th>
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "التفاصيل"
                                                            : "Particulars"}
                                                    </span>
                                                </th>
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "الكمية"
                                                            : "Qty"}
                                                    </span>
                                                </th>
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "سعر الوحدة"
                                                            : "Unit Price"}{" "}
                                                    </span>
                                                </th>
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "الخصم"
                                                            : "Discount"}
                                                    </span>
                                                </th>
                                                <th className="bg-transparent">
                                                    <span>
                                                        {selectedLanguage === "arabic"
                                                            ? "المبلغ الإجمالي"
                                                            : "Total Amount"}{" "}
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {/* {Array.isArray(Products) &&
                                                Products.map((item, index) => (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ whiteSpace: 'normal' }}>{item.product_name}</td>
                                                        <td>
                                                            {item?.is_box == 1
                                                                ? `${item.boxqty} (x${parseInt(item.qty) ||
                                                                0 / parseInt(item.boxqty) ||
                                                                0
                                                                })`
                                                                : item.qty}
                                                        </td>
                                                        <td>{item.sales_price}</td>
                                                        <td>
                                                            {item.discount || 0}{" "}
                                                            {item.discount_type == "1" ? "%" : "RO"}
                                                        </td>
                                                        <td>{item.amount_per_price}</td>
                                                    </tr>
                                                ))} */}

                                            {Products?.map((item, index) => {
                                                const isExpanded = expandedIndex === index;
                                                const serials = JSON.parse(item.serial_number || "[]");
                                                const unitPrice = Number(item.purchase_price); // per unit
                                                const qty = Number(item.qty);

                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className="bg-transparent">
                                                            <td className="bg-transparent">{index + 1}</td>
                                                            <td className="bg-transparent">{item.product_name}</td>
                                                            <td className="bg-transparent">{item?.is_box == 1
                                                                ? `${item.boxqty} (x${parseInt(item.qty) ||
                                                                0 / parseInt(item.boxqty) ||
                                                                0
                                                                })`
                                                                : item.qty}</td>
                                                            <td className="bg-transparent">{item.sales_price}</td>
                                                            <td>
                                                                {item.discount || 0}{" "}
                                                                {item.discount_type == "1" ? "%" : "RO"}
                                                            </td>
                                                            <td
                                                                className="bg-transparent"
                                                                onClick={() => toggleExpand(index)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {(item.amount_per_price)}
                                                                <i className={`fas fa-chevron-${isExpanded ? "up" : "down"} ms-2`}></i>
                                                            </td>
                                                        </tr>

                                                        {isExpanded &&
                                                            Array.from({ length: qty }).map((_, i) => (
                                                                <tr key={`expanded-${index}-${i}`} className="bg-light text-muted">
                                                                    <td className="text-muted bg-light">{i + 1}</td>
                                                                    <td className="text-muted bg-light">{item.product_name} - Serial No: {serials[i] || ''}</td>
                                                                    <td className="text-muted bg-light">1</td>
                                                                    <td className="text-muted bg-light">{item.sales_price}</td>
                                                                    <td>{item.discount || 0}{" "} {item.discount_type == "1" ? "%" : "RO"}
                                                                    </td>
                                                                    <td className="text-muted bg-light">{item.sales_price}</td>

                                                                </tr>
                                                            ))}
                                                    </React.Fragment>
                                                );
                                            })}
                                            {ReturnItem?.length > 0 && (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        <strong>
                                                            {selectedLanguage === "arabic"
                                                                ? "إرجاع المنتجات"
                                                                : "Return Products"}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            )}
                                            {Array.isArray(ReturnItem) &&
                                                ReturnItem.map((item, index) => (
                                                    <tr key={`additional-product-${index}`}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.product_name}</td>
                                                        <td>{item.qty}</td>
                                                        <td>{item.sales_price}</td>
                                                        <td>
                                                            {item.discount || 0}{" "}
                                                            {item.discount_type == "1" ? "%" : "RO"}
                                                        </td>
                                                        <td className="text-danger">
                                                            {"- " + item.amount_per_price || "N/A"}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>

                                        <tfoot>
                                            <tr>
                                                <br />
                                            </tr>

                                            <tr>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent fw-bold text-end">
                                                    {selectedLanguage === "arabic"
                                                        ? "الإجمالي"
                                                        : "Total"}
                                                </td>
                                                <td className="bg-transparent">
                                                    {Products
                                                        ?.reduce(
                                                            (acc, item) =>
                                                                acc +
                                                                (parseFloat(item?.amount_per_price) || 0),
                                                            0
                                                        )
                                                        .toFixed(3)}
                                                </td>
                                            </tr>

                                            <tr className="d-none">
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent fw-bold text-end">
                                                    {selectedLanguage === "arabic"
                                                        ? "الخصم"
                                                        : "Discount"}
                                                </td>
                                                <td className="bg-transparent">
                                                    {InvoiceDetail.discount}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent fw-bold text-end">
                                                    {selectedLanguage === "arabic"
                                                        ? "الضريبة"
                                                        : "Tax"}
                                                </td>
                                                <td className="bg-transparent">
                                                    {(
                                                        (Products?.reduce(
                                                            (acc, item) =>
                                                                acc +
                                                                (parseFloat(item.amount_per_price) || 0),
                                                            0
                                                        ) /
                                                            100) *
                                                        InvoiceDetail.vat || 0
                                                    ).toFixed(3)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent fw-bold text-end">
                                                    {selectedLanguage === "arabic"
                                                        ? "إرجاع"
                                                        : "Return"}
                                                </td>
                                                <td className="bg-transparent text-danger">
                                                    -
                                                    {ReturnItem
                                                        ?.reduce(
                                                            (acc, item) =>
                                                                acc +
                                                                (parseFloat(item.amount_per_price) || 0),
                                                            0
                                                        )
                                                        .toFixed(3)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent"></td>
                                                <td className="bg-transparent fw-bold text-end">
                                                    {selectedLanguage === "arabic"
                                                        ? "الإجمالي"
                                                        : "Grand Total"}
                                                </td>
                                                <td>
                                                    {parseFloat(InvoiceDetail.total || 0).toFixed(3)}
                                                </td>
                                            </tr>

                                            {InvoiceDetail?.purchase_unit != 1 && (
                                                <tr>
                                                    <td colSpan={6} className="text-center">
                                                        Payment History
                                                    </td>
                                                </tr>
                                            )}

                                            {InvoiceDetail?.purchase_unit != 1 &&
                                                Payment
                                                    ?.filter((item) => item.mop != "2")
                                                    ?.map((item, index) => (
                                                        <tr>
                                                            <td
                                                                colSpan={4}
                                                                className="text-end fw-bold px-2"
                                                            >
                                                                {item.date}
                                                            </td>
                                                            <td
                                                                colSpan={1}
                                                                className="text-end fw-bold px-2"
                                                            >
                                                                {item.mop == "1"
                                                                    ? "Cash"
                                                                    : item.mop == "4"
                                                                        ? "Card"
                                                                        : ""}
                                                            </td>
                                                            <td colSpan={1} className="text-center">
                                                                {parseFloat(item.amount || 0).toFixed(3)}
                                                            </td>
                                                        </tr>
                                                    ))}

                                            {InvoiceDetail?.purchase_unit != 1 && (
                                                <tr>
                                                    <td
                                                        colSpan={5}
                                                        className="text-end fw-bold px-2"
                                                    >
                                                        {"Remaining Balance"}
                                                    </td>
                                                    <td
                                                        colSpan={1}
                                                        className="text-center text-danger"
                                                    >
                                                        {(
                                                            parseFloat(InvoiceDetail.total || 0)
                                                            -
                                                            parseFloat(paidAmount || 0)
                                                        ).toFixed(3)}
                                                    </td>
                                                </tr>
                                            )}

                                            <tr>
                                                <td colSpan={6} className="text-start">
                                                    <p className="my-2">
                                                        <strong>
                                                            {selectedLanguage === "arabic"
                                                                ? "المبلغ بالأحرف:"
                                                                : "Amount In Words:"}
                                                            &nbsp;
                                                            {AmountInWords(InvoiceDetail.total)}
                                                        </strong>
                                                    </p>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="row border-top border-bottom py-3 mx-3">
                            <div className="col-10 col-md-4 d-flex">
                                <div
                                    className="p-2 flex-fill d-flex flex-column"
                                    style={{ border: ".8px solid #dee2e6" }}
                                >
                                    <h6 className="fw-bold">
                                        {selectedLanguage === "arabic"
                                            ? "الشروط والأحكام"
                                            : "Terms & Condition:"}
                                    </h6>
                                    <p className="mt-2 fs-8 flex-grow-1">
                                        {data?.terms_conditions}
                                    </p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4 d-flex">
                                <div
                                    className="p-2 flex-fill d-flex flex-column"
                                    style={{ border: ".8px solid #dee2e6" }}
                                >
                                    <h6 className="fw-bold">
                                        {selectedLanguage === "arabic"
                                            ? "حساب البنك"
                                            : "Bank Account:"}
                                    </h6>
                                    <p className="mt-2  fs-6 flex-grow-1">
                                        <p>Name:{data?.bank_name || "N/A"}</p>
                                        Bank:{data?.bank_branch || "N/A"}
                                        <br />
                                        {data?.account_no
                                            ? `A/C No: ${data.account_no}`
                                            : "N/A"}
                                    </p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4 d-flex">
                                <div
                                    className="p-2 flex-fill d-flex flex-column"
                                    style={{ border: ".8px solid #dee2e6" }}
                                >
                                    <h6 className="fw-bold">
                                        {selectedLanguage === "arabic"
                                            ? "لشركة توب تكنو"
                                            : "For Top Tecno:"}
                                    </h6>
                                    <p className="mt-2  fs-6 flex-grow-1">
                                        {data?.shop_title || "N/A"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>

                    <div className="modal-footer mx-1 mt-4">
                        <button
                            type="button"
                            className={"btn btn-info"}
                            onClick={() => { }}
                        >
                            Print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SalesPrintModal